import { createSlice } from '@reduxjs/toolkit';
import { EmptyObject, PayoutIntentReducerSchema } from 'views/types';

interface PayoutIntentInitialState {
  payoutIntent: PayoutIntentReducerSchema | EmptyObject;
}

const initialState: PayoutIntentInitialState = {
  payoutIntent: {},
};

export const payoutSlice = createSlice({
  name: 'payout',
  initialState,
  reducers: {
    setPayoutIntentData(state, action) {
      return {
        ...state,
        payoutIntent: {
          // TODO needs to be refactored.
          // weird **legacy** handling of fee and qoute as the same slice in the store.
          // thus when reqeusting a fee, quoteValidTo is not present
          amountFrom: state.payoutIntent.amountFrom,
          quoteValidTo: state.payoutIntent.quoteValidTo,
          ...action.payload,
          additionalAddress: action.payload.additionalAddress || null,
          additionalAddressType: action.payload.additionalAddressType || null,
        },
      };
    },
    setPayoutGatewayAccess(state, action) {
      const payoutIntent = action.payload;
      return {
        ...state,
        payoutIntent,
      };
    },
    updatePayoutIntentData(state, action) {
      return {
        ...state,
        payoutIntent: {
          ...state.payoutIntent,
          ...action.payload,
        },
      };
    },
  },
});

export const { setPayoutIntentData, updatePayoutIntentData, setPayoutGatewayAccess } =
  payoutSlice.actions;
export default payoutSlice.reducer;
